import React from "react";
import { Route, Switch, Redirect } from 'react-router-dom';
import { useSelector } from "react-redux";
import { useTranslation } from 'react-i18next';

import Home, { ALLOWED_PATHS as HOME_PATHS } from "./Home";
import Publisher, { ALLOWED_PATHS as PUBLISHER_PATHS } from './Publisher';
import Advertiser, { ALLOWED_PATHS as ADVERTISER_PATHS } from './Advertiser';
import NotFound from '../misc/NotFound';

import Balaclava from 'cityads-v3/components/Balaclava';
import { CookiePolicyPopup } from 'cityads-v3/components/CookiePolicy/CookiePolicy';

import { RootState } from "cityads-v3/types/reducer";

export default function Main(): JSX.Element {
  const languageList = useSelector((state: RootState) => state.language.languageList)
  const { t } = useTranslation(['main'])
  return (
    <>
      <Balaclava
        slogan={t('slogan')}
        menuShow={true}
        menu={[
          {
            id: 'publisher',
            title: t('main:tab_publisher'),
            route: '/main/publisher'
          }, {
            id: 'advertiser',
            title: t('main:tab_advertiser'),
            route: '/main/advertiser'
          }
        ]}
      />

      <Switch>
        <Route strict exact path={'/main/publisher/:sub(' + PUBLISHER_PATHS.join('|') + ')?'} component={Publisher} />
        <Route strict exact path={'/main/advertiser/:sub(' + ADVERTISER_PATHS.join('|') + ')?'} component={Advertiser} />
        <Route path={'*/cookiePolicy'}>
          {() => (
            <CookiePolicyPopup />
          )}
        </Route>
        <Route strict exact path={'/main/:sub(' + HOME_PATHS.join('|') + ')?'} component={Home} />

        <Route path={'/main/financial_api'} render={() => (
          <Redirect to="/main/firano" />
        )} />

        <Route path={'/main/:sub(' + languageList.join('|') + ')'} render={() => (
          <Redirect to="/main" />
        )} />

        <Route component={NotFound} />
      </Switch>
    </>
  )
}
